import React from 'react';
import { Menu, Popconfirm } from 'antd';
import cx from 'classnames';
import CloseProjectIcon from './close-project';
import styles from './styles.module.scss';
const MenuCloseButton = props => {
  const {
    onConfirm
  } = props;
  return <Menu className={cx('close-button', styles.menuCloseButton)}>
      <Menu.Item key="1">
        <Popconfirm title="Are you sure you want to close this project?" onConfirm={onConfirm} okText="Yes" cancelText="No">
          <span className={styles.closeButton}>
            <CloseProjectIcon className={styles.closeIcon} /> CLOSE PROJECT
          </span>
        </Popconfirm>
      </Menu.Item>
    </Menu>;
};
export default MenuCloseButton;